export default "__VITE_ASSET__ea3f0e81__"